// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Permissions__scaffold__kafd5{height:100%}.Permissions__rightColumn__CF4Yt{height:100%;overflow:hidden;padding:0 !important}
`, "",{"version":3,"sources":["webpack://./src/js/apps/pages/permissions/containers/Permissions.scss"],"names":[],"mappings":"AAAA,8BACI,WAAY,CACf,iCAGG,WAAY,CACZ,eAAgB,CAChB,oBAAqB","sourcesContent":[".scaffold {\n    height: 100%;\n}\n\n.rightColumn {\n    height: 100%;\n    overflow: hidden;\n    padding: 0 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scaffold": `Permissions__scaffold__kafd5`,
	"rightColumn": `Permissions__rightColumn__CF4Yt`
};
export default ___CSS_LOADER_EXPORT___;
